<div class="flex flex-col gap-4">
  @if (isProduction) {
    <pr-information-box theme="warn">
      <div class="flex flex-col items-center justify-between gap-2 md:flex-row">
        <p class="!m-0">
          Test accounts are not available in the live environment. To create a
          test account, please login to the
          <a href="https://partners.staging.principle.dental" target="_blank"
            >Partners Portal</a
          >
          <a href="https://partners.staging.principle.dental" target="_blank">
            <mat-icon class="icon-sm">open_in_new</mat-icon>
          </a>
          in our Staging environment.
        </p>
      </div>
    </pr-information-box>
  } @else {
    <pr-information-box>
      <div>
        Create a test account to explore our APIs and features, test your app
        integration, and preview functionality before publishing.
      </div>

      <div>
        All test accounts are created on our Staging environment. Please
        <a href="https://staging.principle.dental/register"
          >register an account</a
        >
        <a href="https://staging.principle.dental/register" target="_blank">
          <mat-icon class="icon-sm">open_in_new</mat-icon>
        </a>
        before logging in for the first time.
      </div>

      <div>
        <a href="https://staging.principle.dental/login" target="_blank"
          >Login to test accounts</a
        >
        <a href="https://staging.principle.dental/login" target="_blank">
          <mat-icon class="icon-sm">open_in_new</mat-icon>
        </a>
      </div>
    </pr-information-box>

    <mat-card>
      <mat-card-header class="flex justify-between">
        <mat-card-title>Test Accounts</mat-card-title>
        <mat-card-subtitle
          >Test accounts allow you to kick the tyres</mat-card-subtitle
        >

        <div
          class="flex items-end justify-center gap-2 pb-4"
          [matTooltip]="testAccountTooltip"
          [matTooltipDisabled]="(addTestAccountDisabled$ | async) !== true"
        >
          <button
            mat-flat-button
            color="primary"
            [disabled]="addTestAccountDisabled$ | async"
            (click)="addNewTestAccount()"
          >
            <mat-icon>add</mat-icon>
            Add New Test Account
          </button>
        </div>
      </mat-card-header>
      <mat-card-content>
        <mat-list>
          @if (testAccounts$ | async; as testAccounts) {
            @if (testAccounts.length === 0) {
              <pr-empty-state
                type="text"
                explicitTitle="Add a Test Account to get started"
              />
            } @else {
              @for (testAccount of testAccounts; track testAccount.ref.path) {
                <mat-list-item>
                  <div matListItemTitle>{{ testAccount.name }}</div>
                  <span matListItemLine
                    >Created:
                    {{
                      testAccount.createdAt | moment | amDateFormat: dateFormat
                    }}</span
                  >

                  <div matListItemMeta>
                    <div class="flex items-center">
                      <div class="mat-caption text-sm">
                        <pr-test-account-status
                          dense
                          [status]="testAccount.status"
                        />
                      </div>
                    </div>
                  </div>
                </mat-list-item>
              }
            }
          }
        </mat-list>
      </mat-card-content>
    </mat-card>
  }
</div>
